import { render, staticRenderFns } from "./floor-5-Item.vue?vue&type=template&id=616354d4&scoped=true&"
import script from "./floor-5-Item.vue?vue&type=script&lang=js&"
export * from "./floor-5-Item.vue?vue&type=script&lang=js&"
import style0 from "./floor-5-Item.vue?vue&type=style&index=0&id=616354d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616354d4",
  null
  
)

component.options.__file = "floor-5-Item.vue"
export default component.exports